












import { computed, defineComponent, PropType, toRefs } from '@vue/composition-api';
import SkeletonBasic from '@/components/skeleton/basic.vue';
import { useAdType, useCreativeActionTypeIs, useCreativeIs, useStdCreativeAdgroupIs } from '@tt4b/ttam-hooks';
import { CampaignFormData, AdgroupFormData, NormalCreative, FullNormalFormData, AdType } from '@tt4b/ttam-enums';
import { AdFormat } from './../../index';

const name = 'ttam-ad-format-skeleton';

export default defineComponent({
  name,
  components: {
    SkeletonBasic,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeData: {
      type: Object as PropType<FullNormalFormData>,
      default: () => ({}),
    },
    createMode: {
      type: String,
      default: 'create',
    },
    normalCreativeData: {
      type: Object as PropType<NormalCreative>,
      default: () => ({}),
    },
    currentAdType: {
      type: Number as PropType<AdType>,
      default: undefined,
    },
  },
  setup(props) {
    const { campaignData, adgroupData, createMode, normalCreativeData, creativeData, currentAdType } = toRefs(props);
    const { isEdit } = useCreativeActionTypeIs({ createMode, adgroupFormData: adgroupData });
    const { isNative } = useCreativeIs({
      createMode,
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
      normalCreativeData,
    });
    const { isLiveAds, isOnlySupportTT } = useStdCreativeAdgroupIs({
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
    });
    const { supportAdTypeList } = useAdType({
      isNative,
      isOnlySupportTikTok: isOnlySupportTT,
      campaignFormData: campaignData,
      adgroupFormData: adgroupData,
      creativeFormData: creativeData,
    });
    const { adTypeList } = AdFormat.usePropsAdTypeList({
      isEdit,
      isNative,
      isLiveAds,
      currentAdType,
      supportAdTypeList,
    });

    const adTypeListLen = computed(() => adTypeList.value.length);

    return {
      name,
      isLiveAds,
      adTypeListLen,
    };
  },
});
